export const TELESWAP_REF_CODE = 2;
